/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ShareTokenRouteImport } from './routes/share.$token'
import { Route as SettingsAccountRouteImport } from './routes/settings.account'
import { Route as BillingReturnRouteImport } from './routes/billing.return'
import { Route as SettingsAccountIndexRouteImport } from './routes/settings.account.index'
import { Route as SettingsAccountDeletedRouteImport } from './routes/settings.account.deleted'

const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareTokenRoute = ShareTokenRouteImport.update({
  id: '/share/$token',
  path: '/share/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsAccountRoute = SettingsAccountRouteImport.update({
  id: '/settings/account',
  path: '/settings/account',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingReturnRoute = BillingReturnRouteImport.update({
  id: '/billing/return',
  path: '/billing/return',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsAccountIndexRoute = SettingsAccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsAccountRoute,
} as any)
const SettingsAccountDeletedRoute = SettingsAccountDeletedRouteImport.update({
  id: '/deleted',
  path: '/deleted',
  getParentRoute: () => SettingsAccountRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/pricing': typeof PricingRoute
  '/billing/return': typeof BillingReturnRoute
  '/settings/account': typeof SettingsAccountRouteWithChildren
  '/share/$token': typeof ShareTokenRoute
  '/settings/account/deleted': typeof SettingsAccountDeletedRoute
  '/settings/account/': typeof SettingsAccountIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/pricing': typeof PricingRoute
  '/billing/return': typeof BillingReturnRoute
  '/share/$token': typeof ShareTokenRoute
  '/settings/account/deleted': typeof SettingsAccountDeletedRoute
  '/settings/account': typeof SettingsAccountIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/pricing': typeof PricingRoute
  '/billing/return': typeof BillingReturnRoute
  '/settings/account': typeof SettingsAccountRouteWithChildren
  '/share/$token': typeof ShareTokenRoute
  '/settings/account/deleted': typeof SettingsAccountDeletedRoute
  '/settings/account/': typeof SettingsAccountIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/pricing'
    | '/billing/return'
    | '/settings/account'
    | '/share/$token'
    | '/settings/account/deleted'
    | '/settings/account/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/pricing'
    | '/billing/return'
    | '/share/$token'
    | '/settings/account/deleted'
    | '/settings/account'
  id:
    | '__root__'
    | '/'
    | '/pricing'
    | '/billing/return'
    | '/settings/account'
    | '/share/$token'
    | '/settings/account/deleted'
    | '/settings/account/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PricingRoute: typeof PricingRoute
  BillingReturnRoute: typeof BillingReturnRoute
  SettingsAccountRoute: typeof SettingsAccountRouteWithChildren
  ShareTokenRoute: typeof ShareTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share/$token': {
      id: '/share/$token'
      path: '/share/$token'
      fullPath: '/share/$token'
      preLoaderRoute: typeof ShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/account': {
      id: '/settings/account'
      path: '/settings/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof SettingsAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/return': {
      id: '/billing/return'
      path: '/billing/return'
      fullPath: '/billing/return'
      preLoaderRoute: typeof BillingReturnRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/account/': {
      id: '/settings/account/'
      path: '/'
      fullPath: '/settings/account/'
      preLoaderRoute: typeof SettingsAccountIndexRouteImport
      parentRoute: typeof SettingsAccountRoute
    }
    '/settings/account/deleted': {
      id: '/settings/account/deleted'
      path: '/deleted'
      fullPath: '/settings/account/deleted'
      preLoaderRoute: typeof SettingsAccountDeletedRouteImport
      parentRoute: typeof SettingsAccountRoute
    }
  }
}

interface SettingsAccountRouteChildren {
  SettingsAccountDeletedRoute: typeof SettingsAccountDeletedRoute
  SettingsAccountIndexRoute: typeof SettingsAccountIndexRoute
}

const SettingsAccountRouteChildren: SettingsAccountRouteChildren = {
  SettingsAccountDeletedRoute: SettingsAccountDeletedRoute,
  SettingsAccountIndexRoute: SettingsAccountIndexRoute,
}

const SettingsAccountRouteWithChildren = SettingsAccountRoute._addFileChildren(
  SettingsAccountRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PricingRoute: PricingRoute,
  BillingReturnRoute: BillingReturnRoute,
  SettingsAccountRoute: SettingsAccountRouteWithChildren,
  ShareTokenRoute: ShareTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
